/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/6/15 下午4:01
 */

import React from "react";
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Modal, Row, Table } from "react-bootstrap";
import { connect } from "react-redux";
import Waiting from "./Waiting";
import * as api from "../api";
import Error2 from "./Error2";
import moment from "moment";
import * as actions from "../actions";
import ThePagination from "./Pagination";
import ConfirmationOld from "./ConfirmationOld"

// @connect((state) => {
//     onUnactive: ({}, {id, course}) => actions.requestUnactive({id, course})
// })
class Editing extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            purchase: null
        }
    }

    onChange(key, value) {
        const { purchase } = this.state;
        purchase[key] = value;
        this.forceUpdate();
    }

    componentWillReceiveProps(props) {
        this.setState({ purchase: props.purchase })
    }
    increase(key, value) {
        const { purchase } = this.state;
        purchase[key] = value + 86400;
        this.forceUpdate();
    }
    decrease(key, value) {
        const { purchase } = this.state;
        purchase[key] = value - 86400;
        this.forceUpdate();
    }
    increasem(key, value) {
        const { purchase } = this.state;
        purchase[key] = value + 2592000;
        this.forceUpdate();
    }
    decreasem(key, value) {
        const { purchase } = this.state;
        purchase[key] = value - 2592000;
        this.forceUpdate();
    }
    increasey(key, value) {
        const { purchase } = this.state;
        purchase[key] = value + 31536000;
        this.forceUpdate();
    }
    decreasey(key, value) {
        const { purchase } = this.state;
        purchase[key] = value - 31536000;
        this.forceUpdate();
    }

    render() {
        const { isVisible, onOk, onCancel } = this.props;
        const { purchase } = this.state;
        return (
            <Modal.Dialog style={{ display: isVisible ? 'block' : 'none' }}>
                <Modal.Header>
                    <Modal.Title>编辑</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        purchase ?
                            <Form horizontal>
                                <FormGroup>
                                    <Col sm={2}>
                                        <ControlLabel>渠道</ControlLabel>
                                    </Col>
                                    <Col sm={10}>
                                        <FormControl
                                            value={purchase.remark}
                                            onChange={e => this.onChange('remark', e.target.value)} />
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col sm={2}>
                                        <ControlLabel>激活时间</ControlLabel>
                                    </Col>
                                    <Col sm={10}>
                                        <FormControl
                                            value={moment.unix(purchase.paidAt).locale('zh_CN').format('LLLLss秒')}
                                            // value={purchase.paidAt}
                                            onChange={e => this.onChange('paidAt', e.target.value)} />
                                        <Button onClick={() => this.increase('paidAt', purchase.paidAt)}>加一天</Button>
                                        <Button onClick={() => this.decrease('paidAt', purchase.paidAt)}>减一天</Button>
                                        <Button onClick={() => this.increasem('paidAt', purchase.paidAt)}>加一月</Button>
                                        <Button onClick={() => this.decreasem('paidAt', purchase.paidAt)}>减一月</Button>
                                        <Button onClick={() => this.increasey('paidAt', purchase.paidAt)}>加一年</Button>
                                        <Button onClick={() => this.decreasey('paidAt', purchase.paidAt)}>减一年</Button>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col sm={2}>
                                        <ControlLabel>到期时间</ControlLabel>
                                    </Col>
                                    <Col sm={10}>
                                        <FormControl
                                            value={moment.unix(purchase.expirationTime).locale('zh_CN').format('LLLLss秒')}
                                            onChange={e => this.onChange('expirationTime', e.target.value)} />
                                        <Button onClick={() => this.increase('expirationTime', purchase.expirationTime)}>加一天</Button>
                                        <Button onClick={() => this.decrease('expirationTime', purchase.expirationTime)}>减一天</Button>
                                        <Button onClick={() => this.increasem('expirationTime', purchase.expirationTime)}>加一月</Button>
                                        <Button onClick={() => this.decreasem('expirationTime', purchase.expirationTime)}>减一月</Button>
                                        <Button onClick={() => this.increasey('expirationTime', purchase.expirationTime)}>加一年</Button>
                                        <Button onClick={() => this.decreasey('expirationTime', purchase.expirationTime)}>减一年</Button>
                                    </Col>
                                </FormGroup>
                            </Form> : null
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onOk(purchase)} bsStyle="primary">确定</Button>
                    <Button onClick={() => onCancel()}>取消</Button>
                </Modal.Footer>
            </Modal.Dialog>
        )
    }
}

// 批量编辑组件
class BatchEditing extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.state = {
            // 基于第一个选中的purchase初始化
            purchase: null,
            batchMode: true // 标记这是批量编辑模式
        }
    }

    componentDidMount() {
        this.initializePurchaseData();
    }

    componentDidUpdate(prevProps) {
        // 当选中的purchases发生变化或组件显示状态变化时，重新初始化数据
        if ((this.props.selectedPurchases !== prevProps.selectedPurchases ||
            this.props.isVisible !== prevProps.isVisible) &&
            this.props.isVisible &&
            this.props.selectedPurchases &&
            this.props.selectedPurchases.length > 0) {
            this.initializePurchaseData();
        }
    }

    initializePurchaseData() {
        if (this.props.selectedPurchases && this.props.selectedPurchases.length > 0) {
            // 使用第一个purchase作为模板，但清空某些字段用于批量设置
            const firstPurchase = this.props.selectedPurchases[0];
            // console.log('初始化批量编辑数据:', firstPurchase); // 调试信息
            this.setState({
                purchase: {
                    ...firstPurchase,
                    remark: '', // 清空渠道让用户设置
                    // 保持时间字段，用户可以调整
                }
            });
        }
    }

    onChange(key, value) {
        const { purchase } = this.state;
        purchase[key] = value;
        this.forceUpdate();
    }

    // 完全复制单个编辑的时间调整方法
    increase(key, value) {
        const { purchase } = this.state;
        purchase[key] = value + 86400;
        this.forceUpdate();
    }
    decrease(key, value) {
        const { purchase } = this.state;
        purchase[key] = value - 86400;
        this.forceUpdate();
    }
    increasem(key, value) {
        const { purchase } = this.state;
        purchase[key] = value + 2592000;
        this.forceUpdate();
    }
    decreasem(key, value) {
        const { purchase } = this.state;
        purchase[key] = value - 2592000;
        this.forceUpdate();
    }
    increasey(key, value) {
        const { purchase } = this.state;
        purchase[key] = value + 31536000;
        this.forceUpdate();
    }
    decreasey(key, value) {
        const { purchase } = this.state;
        purchase[key] = value - 31536000;
        this.forceUpdate();
    }

    render() {
        const { isVisible, onOk, onCancel, selectedPurchases } = this.props;
        const { purchase } = this.state;

        return (
            <Modal.Dialog style={{ display: isVisible ? 'block' : 'none' }}>
                <Modal.Header>
                    <Modal.Title>批量编辑 (已选择 {selectedPurchases ? selectedPurchases.length : 0} 条记录)</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        purchase ?
                            <Form horizontal>
                                <FormGroup>
                                    <Col sm={2}>
                                        <ControlLabel>渠道</ControlLabel>
                                    </Col>
                                    <Col sm={10}>
                                        <FormControl
                                            value={purchase.remark}
                                            onChange={e => this.onChange('remark', e.target.value)} />
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col sm={2}>
                                        <ControlLabel>激活时间</ControlLabel>
                                    </Col>
                                    <Col sm={10}>
                                        <FormControl
                                            value={moment.unix(purchase.paidAt).locale('zh_CN').format('LLLLss秒')}
                                            onChange={e => this.onChange('paidAt', e.target.value)} />
                                        <Button onClick={() => this.increase('paidAt', purchase.paidAt)}>加一天</Button>
                                        <Button onClick={() => this.decrease('paidAt', purchase.paidAt)}>减一天</Button>
                                        <Button onClick={() => this.increasem('paidAt', purchase.paidAt)}>加一月</Button>
                                        <Button onClick={() => this.decreasem('paidAt', purchase.paidAt)}>减一月</Button>
                                        <Button onClick={() => this.increasey('paidAt', purchase.paidAt)}>加一年</Button>
                                        <Button onClick={() => this.decreasey('paidAt', purchase.paidAt)}>减一年</Button>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col sm={2}>
                                        <ControlLabel>到期时间</ControlLabel>
                                    </Col>
                                    <Col sm={10}>
                                        <FormControl
                                            value={moment.unix(purchase.expirationTime).locale('zh_CN').format('LLLLss秒')}
                                            onChange={e => this.onChange('expirationTime', e.target.value)} />
                                        <Button onClick={() => this.increase('expirationTime', purchase.expirationTime)}>加一天</Button>
                                        <Button onClick={() => this.decrease('expirationTime', purchase.expirationTime)}>减一天</Button>
                                        <Button onClick={() => this.increasem('expirationTime', purchase.expirationTime)}>加一月</Button>
                                        <Button onClick={() => this.decreasem('expirationTime', purchase.expirationTime)}>减一月</Button>
                                        <Button onClick={() => this.increasey('expirationTime', purchase.expirationTime)}>加一年</Button>
                                        <Button onClick={() => this.decreasey('expirationTime', purchase.expirationTime)}>减一年</Button>
                                    </Col>
                                </FormGroup>
                            </Form> : null
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onOk(purchase)} bsStyle="primary">确认批量编辑</Button>
                    <Button onClick={() => onCancel()}>取消</Button>
                </Modal.Footer>
            </Modal.Dialog>
        )
    }
}

// 批量处理结果对话框
class BatchResult extends React.Component {
    render() {
        const { isVisible, result, onOk } = this.props;

        if (!result) return null;

        return (
            <Modal.Dialog style={{ display: isVisible ? 'block' : 'none' }}>
                <Modal.Header>
                    <Modal.Title>批量处理结果</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>总计: {result.total} 条记录</p>
                    <p style={{ color: 'green' }}>成功: {result.success} 条</p>
                    <p style={{ color: 'red' }}>失败: {result.error} 条</p>
                    {result.errors && result.errors.length > 0 && (
                        <div>
                            <h5>错误详情:</h5>
                            <ul>
                                {result.errors.map((error, index) => (
                                    <li key={index} style={{ color: 'red' }}>{error}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onOk} bsStyle="primary">确定</Button>
                </Modal.Footer>
            </Modal.Dialog>
        )
    }
}

export default class CourseActive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phone: "",
            courseIds: "",
            purchases: [],
            loading: false,
            error: null,
            page: 0,
            total: 0,
            editing: false,
            activeIndex: 0,
            choiceActive: false,
            query_phone: null,
            selectedItems: [], // 选中的记录ID列表
            batchEditing: false, // 批量编辑对话框状态
            batchProgress: false, // 批量处理进度
            batchResult: null // 批量处理结果
        }
    }

    onQuery(phone) {
        const { page } = this.state;
        this.setState({ loading: true });
        api.getCoursePurchases({ page, phone })
            .then(json => this.setState({
                loading: false,
                purchases: json.data || [], // 确保data不为null/undefined
                error: null,
                page: json.paging.page,
                total: json.paging.total,
                query_phone: phone,
                selectedItems: [] // 查询后清空选择
            }))
            .catch(error => this.setState({
                loading: false, // 重要：出错时也要关闭loading状态
                error,
                purchases: [] // 出错时清空purchases数组
            }))
    }

    onUpdatePurchase(id, purchase) {
        const { query_phone } = this.state;
        this.setState({ loading: true });
        api.updateCoursePurchase(id, purchase)
            .then(json => this.onQuery(query_phone))
            .catch(error => this.setState({
                loading: false, // 出错时关闭loading状态
                error
            }))
    }

    onActive(createUser = false, activeAdvance = false, activePartAdvance = false) {
        const { phone, courseIds } = this.state;
        this.setState({ loading: true });
        api.activeCourse(phone, createUser, activeAdvance, activePartAdvance, courseIds)
            .then(json => this.onQuery())
            .catch(error => this.setState({ loading: false, error }))
    }

    onDeactive(userId, courseId) {
        const { query_phone } = this.state;
        api.deactiveCourse(userId, courseId)
            .then(json => this.onQuery(query_phone))
            .catch(error => this.setState({ loading: false, error }))
    }

    onRegister() {
        const { phone } = this.state;
        this.setState({ loading: true });
        api.register_ai_user(phone, '123456')
            .then(json => this.setState({ loading: false }))
            .catch(error => this.setState({ error, loading: false }))
    }

    componentDidMount() {
        this.onQuery();
    }

    // 选择/取消选择单个记录
    onSelectItem(purchaseId, checked) {
        const { selectedItems } = this.state;
        if (checked) {
            this.setState({ selectedItems: [...selectedItems, purchaseId] });
        } else {
            this.setState({ selectedItems: selectedItems.filter(id => id !== purchaseId) });
        }
    }

    // 全选/反选
    onSelectAll() {
        const { purchases, selectedItems } = this.state;
        if (selectedItems.length === purchases.length) {
            // 当前全选，则清空选择
            this.setState({ selectedItems: [] });
        } else {
            // 选择全部
            this.setState({ selectedItems: purchases.map(p => p.id) });
        }
    }

    // 批量编辑 - 完全模仿单个编辑的处理方式
    async onBatchEdit(editedPurchase) {
        const { selectedItems, purchases } = this.state;
        const selectedPurchases = purchases.filter(p => selectedItems.includes(p.id));

        this.setState({ batchProgress: true });

        let successCount = 0;
        let errorCount = 0;
        const errors = [];

        for (let i = 0; i < selectedPurchases.length; i++) {
            const originalPurchase = selectedPurchases[i];
            try {
                // 为每个选中的purchase创建更新数据
                const purchaseToUpdate = {
                    ...originalPurchase,
                    // 应用编辑的更改
                    remark: editedPurchase.remark && editedPurchase.remark.trim() !== ''
                        ? editedPurchase.remark.trim()
                        : originalPurchase.remark, // 如果新值为空，保持原值
                    paidAt: editedPurchase.paidAt,
                    expirationTime: editedPurchase.expirationTime
                };

                // 完全按照单个编辑的方式调用API
                await api.updateCoursePurchase(originalPurchase.id, purchaseToUpdate);
                successCount++;
            } catch (error) {
                errorCount++;
                errors.push(`ID ${originalPurchase.id}: ${error.message || error}`);
            }
        }

        this.setState({
            batchProgress: false,
            batchResult: {
                total: selectedPurchases.length,
                success: successCount,
                error: errorCount,
                errors
            }
        });

        // 刷新数据
        const { query_phone } = this.state;
        this.onQuery(query_phone);
    }


    render() {
        const { phone, courseIds, purchases, loading, error, page, total, editing, activeIndex, choiceActive, query_phone, selectedItems, batchEditing, batchProgress, batchResult } = this.state;
        return (
            <div>
                <Waiting isVisible={loading} />
                <Error2 error={error} onOk={() => this.setState({ error: null })} />
                <ConfirmationOld
                    isVisible={choiceActive}
                    onCancel={() => this.setState({ choiceActive: false })}
                    onOk={() => this.setState({ choiceActive: false }, () => this.onDeactive(purchases[activeIndex].userId, purchases[activeIndex].courseId))}
                    message='确认取消激活？'
                />
                <Editing
                    isVisible={editing}
                    purchase={purchases[activeIndex]}
                    onCancel={() => this.setState({ editing: false })}
                    onOk={purchase => this.setState({ editing: false }, () => this.onUpdatePurchase(purchases[activeIndex].id, purchase))}
                />
                <BatchEditing
                    isVisible={batchEditing}
                    selectedPurchases={purchases.filter(p => selectedItems.includes(p.id))}
                    onCancel={() => this.setState({ batchEditing: false })}
                    onOk={batchData => this.setState({ batchEditing: false }, () => this.onBatchEdit(batchData))}
                />
                <BatchResult
                    isVisible={!!batchResult}
                    result={batchResult}
                    onOk={() => this.setState({ batchResult: null, selectedItems: [] })}
                />
                <Waiting isVisible={batchProgress} />
                <Row>
                    <Col sm={8}>
                        <Form inline style={{ padding: 3 }}>
                            <input type="text" ref="phone" className="form-control input-sm" placeholder="请输入用户手机号" />
                            &nbsp;
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onQuery(this.refs.phone.value.trim())
                                }}
                                bsSize="sm" bsStyle="success">搜索</Button>
                            &nbsp;
                        </Form>
                        {/* <Form inline style={{padding: 3}}>
                            <FormControl bsSize="sm" placeholder="请输入用户手机号" value={phone} onChange={e => {
                                this.setState({phone: e.target.value.trim()})
                            }}/>
                            &nbsp;
                            <FormControl bsSize="sm" placeholder="激活逗号分隔的课程id" style={{width: '150px', border: 'solid 1px red'}} value={courseIds} onChange={e => {
                                this.setState({courseIds: e.target.value.trim()})
                            }}/>
                            &nbsp;
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onActive(false, false)
                                }}
                                bsSize="sm" bsStyle="success">激活新手入门</Button>
                            &nbsp;
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onActive(false, true)
                                }}
                                bsSize="sm" bsStyle="success">激活所有进阶</Button>
                            &nbsp;
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onActive(true, false)
                                }}
                                bsSize="sm" bsStyle="success">创建用户并激活新手入门</Button>
                            &nbsp;
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onRegister();
                                }}
                                bsSize="sm" bsStyle="success">创建用户</Button>
                            &nbsp;
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onActive(false, false, true)
                                }}
                                bsSize="sm" bsStyle="danger">激活附送进阶</Button>
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onActive(true, true)
                                }}
                                bsSize="sm" bsStyle="danger">执行红框</Button>

                        </Form> */}

                        {/* <a href="http://admin.iguitar.immusician.com/member/list?bundle=com.immusician.music" target="_blank">所有用户列表</a> */}

                    </Col>
                    <Col sm={4}>

                        <div className="text-right" style={{ padding: 3 }}>
                            <Button
                                bsSize="sm"
                                bsStyle="info"
                                disabled={selectedItems.length === 0}
                                onClick={() => this.setState({ batchEditing: true })}
                            >
                                批量编辑 ({selectedItems.length})
                            </Button>
                            &nbsp;
                            <Button
                                bsSize="sm"
                                onClick={() => this.setState({ selectedItems: [] })}
                                disabled={selectedItems.length === 0}
                            >
                                清空选择
                            </Button>
                        </div>
                    </Col>
                </Row>

                <Table bordered hover striped condensed responsive>
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    checked={purchases.length > 0 && selectedItems.length === purchases.length}
                                    onChange={() => this.onSelectAll()}
                                />
                                &nbsp;全选
                            </th>
                            <th>用户</th>
                            <th>课程</th>
                            <th>激活时间</th>
                            <th>渠道</th>
                            <th>操作</th>
                            <th>到期时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            purchases.length > 0 ? (
                                purchases.map((purchase, index) => {
                                    const isSelected = selectedItems.includes(purchase.id);
                                    return (
                                        <tr key={index} style={{ backgroundColor: isSelected ? '#f5f5f5' : 'transparent' }}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={isSelected}
                                                    onChange={(e) => this.onSelectItem(purchase.id, e.target.checked)}
                                                />
                                            </td>
                                            <td><a href={`http://aimusic.admin.immusician.com/member/list?t=&do=uid&uid=${purchase.userId}`} target="_blank">{purchase.user ? `${purchase.user.phone}: ${purchase.userId}: [${purchase.user.device_model}]` : 'NULL'}</a></td>
                                            <td>{purchase.course ? purchase.course.name : 'NULL'}</td>
                                            <td>{moment.unix(purchase.paidAt).locale('zh_CN').format('LLLL')}</td>
                                            <td>{purchase.remark}</td>
                                            <td>
                                                <Button
                                                    bsSize="sm"
                                                    bsStyle="warning"
                                                    onClick={() => this.setState({
                                                        activeIndex: index,
                                                        choiceActive: true
                                                    })}
                                                //         onClick={() => onUnactive({purchase.userId, purchase.course.id})}
                                                >取消激活</Button>
                                                &nbsp;
                                                <Button
                                                    bsSize="sm"
                                                    bsStyle="primary"
                                                    onClick={() => this.setState({
                                                        editing: true,
                                                        activeIndex: index
                                                    })}>编辑</Button>
                                            </td>
                                            <td>{moment.unix(purchase.expirationTime).locale('zh_CN').format('LLLL')}</td>
                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                        {loading ? '数据加载中...' : '暂无数据'}
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>

                <ThePagination
                    page={page} size={10} total={total}
                    onSelect={(page) => this.setState({ page }, () => this.onQuery(query_phone))} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/CourseActive.js